export const STATUS_DOT = {
  "Open": "#B03A2E",
  "In Progress": "#C8842E",
  "Completed": "#2F7D4F",
  "On Hold": "#C8A84E",
  "Cancelled": "#8B8F99",
  "NA": "#AFB2BA",
};

export const STATUS_PILL_CLASS = {
  "Open": "mv2-stpill st-open",
  "In Progress": "mv2-stpill st-inprogress",
  "On Hold": "mv2-stpill st-onhold",
  "Completed": "mv2-stpill st-completed",
  "Cancelled": "mv2-stpill st-cancelled",
  "NA": "mv2-stpill st-na",
};

export const IMPL_STATUS_OPTIONS = [
  "Open", "In Progress", "On Hold", "Completed", "Cancelled", "NA",
];

export const TYPE_OPTIONS = ["New", "Enhancement", "Technical Debt"];
export const TASK_VISIBILITY_OPTIONS = ["Public", "Internal", "Private"];
export const SOURCE_OPTIONS = ["Web", "Mobile", "API", "Infra", "Others"];
export const REPORTING_CHANNEL_OPTIONS = [
  "Email", "Call", "Client Portal", "WhatsApp", "Telegram",
  "Internal QA", "External QA", "Monitoring", "Meeting",
];
export const PROJECT_STATUS_OPTIONS = ["Active", "Inactive", "Closed"];
export const EPIC_STATUS_OPTIONS = [
  "Planning", "In-Progress", "Regression Testing", "UAT Released",
  "Staging Released", "Live", "Closed",
];

export const BOARD_COLS = ["Open", "In Progress", "On Hold", "Completed", "Cancelled"];

export const FILTER_FIELDS = [
  { key: "title", label: "Title", type: "text" },
  { key: "description", label: "Description", type: "text" },
  { key: "customer", label: "Customer" },
  { key: "project", label: "Project" },
  { key: "project_status", label: "Project Status", staticOptions: PROJECT_STATUS_OPTIONS },
  { key: "epic_name", label: "Epic" },
  { key: "epic_status", label: "Epic Status", staticOptions: EPIC_STATUS_OPTIONS },
  { key: "feature", label: "Feature" },
  { key: "sub_feature", label: "Sub-feature" },
  { key: "status", label: "Status", staticOptions: IMPL_STATUS_OPTIONS },
  { key: "tmm_team_name", label: "Team" },
  { key: "tmm_member", label: "Assignee" },
  { key: "am_name", label: "AM Name" },
  { key: "new_enhancement", label: "Type", staticOptions: TYPE_OPTIONS },
  { key: "visibility", label: "Visibility", staticOptions: TASK_VISIBILITY_OPTIONS },
  { key: "source", label: "Source", staticOptions: SOURCE_OPTIONS },
  { key: "reporting_channel", label: "Reporting Channel", staticOptions: REPORTING_CHANNEL_OPTIONS },
  { key: "created_by_name", label: "Created By" },
  { key: "customer_due_date", label: "Due Date", type: "daterange" },
  { key: "tags", label: "Tags", type: "choice" },
];

export const DEFAULT_ALL_TASKS_APPLIED_FILTERS = {
  status: {
    op: "is_not",
    values: ["Completed", "Cancelled"],
  },
};
